<template>
  <div id="familyPage">
    <div class="screenBox">
      <div class="selectCls">
        <div class="selTitle">城市</div>
        <el-dropdown trigger="click" @command="citySeleBtnAction">
          <el-button class="dropdownBtn">
            <div class="selBtnContent">
              {{ curSelectedCity.name }}
              <i class="el-icon-arrow-down el-icon--right"></i>
            </div>
          </el-button>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item
              v-for="(cityItem, index) in cityData"
              :key="index"
              :command="cityItem"
              >{{ cityItem.name }}</el-dropdown-item
            >
          </el-dropdown-menu>
        </el-dropdown>
      </div>
      <div class="selectCls redionCls">
        <div class="selTitle">区域</div>
        <el-dropdown trigger="click" @command="redionSeleBtnAction">
          <el-button class="dropdownBtn">
            <div class="selBtnContent">
              {{ curSelectedRedion }}
              <i class="el-icon-arrow-down el-icon--right"></i>
            </div>
          </el-button>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item
              v-for="(redionItem, index) in curSelectedCity.redions"
              :key="index"
              :command="redionItem"
              >{{ redionItem }}</el-dropdown-item
            >
          </el-dropdown-menu>
        </el-dropdown>
      </div>
      <div class="operateBtn">
        <div class="queryBtn" @click="queryAction">查询</div>
        <div class="resetBtn" @click="resetAction">重置</div>
      </div>
    </div>
    <el-divider></el-divider>
    <custom-Table
      :dataSource="familyInfo"
      @statusBtnAction="statusTapAction"
      @equipmentBtnAction="equipmentTapAction"
      @showBtnAction="shouldShowBtnAction"
    ></custom-Table>
    <el-pagination
      class="pageControl"
      background
      layout="prev, pager, next, total"
      :page-size="familyInfo.length"
      :page-count="pageSize"
      :current-page.sync="curPageNum"
    ></el-pagination>
  </div>
</template>
<script>
import customTable from "@/components/subComponents/customTable/customTable";
import requestObjc from "@/utils/requestObjc";
import pathKey from "@/router/routerKey";
import mainStore from "@/store/storeMain";
import { mapMutations } from "vuex";
import { removeStore, userInfo_key } from "@/utils/localCache";

export default {
  name: "familyPage",
  store: mainStore,
  components: {
    customTable,
  },
  data() {
    return {
      curSelectedCity: {
        type: Object,
      },
      curSelectedRedion: {
        type: String,
      },
      cityData: [
        {
          name: "全部",
          redions: ["全部"],
        },
        {
          name: "上海",
          redions: ["全部", "闵行区", "徐汇区", "嘉定区"],
        },
        {
          name: "南京",
          redions: ["全部", "123", "321", "1234567"],
        },
        {
          name: "北京",
          redions: ["全部", "朝阳区", "中原区", "金水区"],
        },
      ],
      familyInfo: [], //列表数据源
      pageSize: 1, //总页数
      curPageNum: 1, //当前页号
    };
  },
  watch: {
    //当前页号
    curPageNum: function (value) {
      this.requestData(value);
    },
  },
  created() {
    this.requestData(1);
    this.curSelectedCity = this.cityData[0];
    this.curSelectedRedion = this.curSelectedCity.redions[0];
  },
  methods: {
    ...mapMutations({
      changeCurHouseInfo: "updateCurHouseInfo",
    }),
    requestData(pageIndex) {
      var params = {
        pageIndex: pageIndex,
        pageNum: 10,
      };
      requestObjc
        .requestHomeData(params)
        .then((res) => {
          var data = res.data;
          this.$set(this, "pageSize", data.pageSize);
          var houseArr = [];
          if (data.houses != null) {
            data.houses.forEach((value, index) => {
              var houseData = value;
              houseData.phone = houseData.phone || "未知手机";
              houseData.userName = houseData.userName || "未知用户";
              houseData.city = houseData.city || "未知城市";
              houseData.district = houseData.district || "未知区域";
              houseData.houseName = houseData.houseName || "未知名称";
              houseData.show = houseData.show;
              houseArr.push(houseData);
            });
          }
          this.$set(this, "familyInfo", houseArr);
        })
        .catch((e) => {
          console.log(e.message);
        });
    },
    //选择城市
    citySeleBtnAction(value) {
      this.curSelectedCity = value;
    },
    //选择区域
    redionSeleBtnAction(value) {
      this.curSelectedRedion = value;
    },
    //查询
    queryAction() {
      //暂时在这里清除缓存
      // removeStore(userInfo_key);
    },
    //重置
    resetAction() {},
    //点击了状态按钮
    statusTapAction(itemData) {
      this.changeCurHouseInfo(itemData[0]);
      // this.$store.commit('updateCurHouseInfo', itemData[0]);
      this.$router.push(pathKey.familyStatusDetailPath);
    },
    //点击了机电按钮
    equipmentTapAction(itemArr) {},
    //标记是否展示数据的按钮
    shouldShowBtnAction(itemArr) {
      var item = itemArr[0];
      var index = itemArr[1];
      var params = {
        isShow: item.show,
      };
      requestObjc
        .updateGatewayIsShow(params, item.gatewayId)
        .then((res) => {
          if (res.code == 200) {
            //修改成功
          } else {
            this.$set(this.familyInfo[index], "show", !item.show);
            //修改失败
            this.$message({
              type: "error",
              message: "网络出错啦~",
            });
          }
        })
        .catch((e) => {
          this.$set(this.familyInfo[index], "show", !item.show);
          this.$message({
            type: "error",
            message: "网络出错啦~",
          });
          console.log(e.message);
        });
    },
  },
};
</script>
<style scoped>
#familyPage {
  width: 90%;
  margin: 0 auto;
  padding: 20px;
}
.screenBox {
  display: flex;
}
.selectCls {
  display: inline-block;
}
.redionCls {
  margin-left: 50px;
}
.selTitle {
  text-align: left;
  margin-bottom: 10px;
  margin-left: 20px;
}
.dropdownBtn {
  width: 174px;
  height: 56px;
  background-color: #ffffff;
  color: #000000;
  border-radius: 28px;
  border-width: 0px;
  box-shadow: 0px 8px 18px 0px rgba(206, 231, 255, 0.21);
}
.selBtnContent {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.operateBtn {
  margin-left: 80px;
  display: flex;
  align-items: flex-end;
}
.queryBtn,
.resetBtn {
  width: 100px;
  height: 46px;
  display: inline-block;
  line-height: 46px;
  border-radius: 28px;
}
.queryBtn {
  color: #ffffff;
  background-color: #2592fa;
  box-shadow: 0px 8px 18px 0px rgba(206, 231, 255, 0.21);
}
.resetBtn {
  margin-left: 20px;
  background-color: #ffffff;
  color: #666666;
  box-shadow: 0px 8px 18px 0px rgba(206, 231, 255, 0.21);
  border-style: none;
}
.resetBtn:hover {
  background-color: #ccc;
  cursor: pointer;
}
.queryBtn:hover {
  background-color: #2592faaa;
  cursor: pointer;
}
.pageControl {
  margin: 30px 30px 30px 0px;
  float: right;
}
</style>


// WEBPACK FOOTER //
// src/components/pages/familyStatus/familyStatus.vue